import * as React from 'react';

import * as styles from './CompareOnboarding.css';

export interface ICompareOnboarding {
  onClose: () => void;
}

export const CompareOnboarding = ({ onClose }: ICompareOnboarding) => (
  <div className={styles['container']}>
    <div className={styles['icon']} />
    <div className={styles['content']}>
      <div className={styles['title']}>Сравнивайте квартиры по параметрам</div>
      <div className={styles['description']}>Пока это работает только с квартирами от&nbsp;застройщиков</div>
    </div>
    <div className={styles['close']} onClick={onClose} />
  </div>
);
